import React, { useEffect, useState } from 'react'
import { Button } from '@mui/material';
import GeneralSettings from './GeneralSettings';
import EmailSettings from './EmailSettings';
import Website from './Website';
import Advanced from './Advanced';
import Security from './Security';
import PleaseWaitPopup from '../../PleaseWaitPopup';
import Integration from './Integration';
import { getGeneralSettings, put_GeneralSetting } from '../../../services/generalSetting';
import { useTheme } from '../../../components/hooks/useTheme';
import colorConfigs from '../../../configs/colorConfigs';
import useGeneral from '../../../components/hooks/useGeneral';
import useAuth from '../../../components/hooks/useAuth';
import SocialMedia from './SocialMedia';
import Cookies from 'js-cookie';
import useTenant from '../../../components/hooks/useTenant';
import { getTimeZones } from '../../../services/Timezone';

export const Admin = () => {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { auth }: any = useAuth();
  const { themeStyles } = useTheme();
  const { handleTenantError }: any = useTenant();
  const { setDateFormat, setTimezoneName, setGeneralSetting }: any = useGeneral();

  const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);
  const [id, setId] = useState<number>(0);
  //General settings
  const [companyName, setCompanyName] = useState<string>("");
  const [country, setCountry] = useState<string>("");
  const [smsSender, setSmsSender] = useState<string>("");
  const [timezone, setTimezone] = useState<string>("");
  const [language, setLanguage] = useState<string>("");
  const [SupportedLanguages, setSupportedLanguages] = useState<any>();
  const [supportedLanguagesArray, setSupportedLanguagesArray] = useState<any[]>([]);
  const [preferredDateFormat, setPreferredDateFormat] = useState<string>("");
  const [metricSystem, setMetricSystem] = useState<string>("");
  const [filePath, setFilePath] = useState<string>("");
  const [favIcon, setFavIcon] = useState<string>("");
  const [rentalAgreementIcon, setRentalAgreementIcon] = useState<string>("");
  const supportedLanguagesOptions: any[] = [
    { value: "English", label: "English" }
  ]
  const [processRunTime, setProcessRunTime] = useState<string>("");
  const [processRunFrequency, setrocessRunFrequency] = useState<string>("");
  const [timezoneOptions, setTimezoneOptions] = useState<any[]>([]);

  //Email Settings
  const [isPretendEmails, setIsPretendEmails] = useState<string>("No");
  const [replyToEmail, setReplyToEmail] = useState<string>("");
  const [isDisabledSmsFailureNotificationEmails, setIsDisabledSmsFailureNotificationEmails] = useState<string>("No");
  const [emailForFailureNotifications, setEmailForFailureNotifications] = useState<string>("");
  const [mainLayout, setMainLayout] = useState<string>("");
  const [emailSignature, setEmailSignature] = useState<string>("");
  const [mailFooter, setMailFooter] = useState<string>("");
  const [isShowLogoOnEmails, setIsShowLogoOnEmails] = useState<string>("No");
  const [mailBarColor, setMailBarColor] = useState<string>("#000000");
  const [emailFilePath, setEmailFilePath] = useState<string>("");
  const [baseUrl, setBaseUrl] = useState<string>("");
  const [showWebcam, setShowWebcam] = useState<boolean>(false);

  //Integration
  const [mailChimpKey, setMailChimpKey] = useState<string>("");
  const [mailgunSender, setMailgunSender] = useState<string>("");
  const [mailgunDomain, setMailgunDomain] = useState<string>("");
  const [googleAnalyticsKey, setGoogleAnalyticsKey] = useState<string>("");
  const [extraCcUsersForSupportTickets, setExtraCcUsersForSupportTickets] = useState<string>("");

  //Website
  const [websiteHeaderColor, setWebsiteHeaderColor] = useState<string>("");
  const [websiteHeaderSubColor, setWebsiteHeaderSubColor] = useState<string>("");
  const [websiteFooterColor, setWebsiteFooterColor] = useState<string>("");
  const [websiteFooterSubColor, setWebsiteFooterSubColor] = useState<string>("");
  const [websiteIndexPageImage, setWebsiteIndexPageImage] = useState<string>("");
  const [websiteSubPageImage, setWebsiteSubPageImage] = useState<string>("");
  const [websiteEmail, setWebsiteEmail] = useState<string>("");
  const [websitePhone, setWebsitePhone] = useState<string>("");
  const [websiteBranch, setWebsiteBranch] = useState<string>("");
  const [disabled, setDisabled] = useState<boolean>(true);

  //Social Media
  const [facebookUrl, setFacebookUrl] = useState<string>("");
  const [twitterUrl, setTwitterUrl] = useState<string>("");
  const [instagramUrl, setInstagramUrl] = useState<string>("");

  useEffect(() => {
    getTimeZones(tenantId)
      .then(res => {
        const data = res?.map((item: any) => ({
          value: item?.id,
          label: item?.name
        }));
        setTimezoneOptions(data);
        handleTenantError(null);
      })
      .catch((error) => {
        setTimezoneOptions([]);
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setPleaseWaitPopup(true);
    getGeneralSettings(tenantId)
      .then(data => {
        setId(data[0].id);
        setCompanyName(data[0].companyName);
        setCountry(data[0].country);
        setSmsSender(data[0].smsSender);
        setTimezone(data[0].timezone);
        setLanguage(data[0].language);
        const supportedArray =
          data[0].supportedLanguages.split(",");

        ;
        setSupportedLanguagesArray(
          supportedLanguagesOptions.filter((item: any) =>
            supportedArray.some((data: string) => item.value === data)
          )
        );

        setSupportedLanguages(
          supportedLanguagesOptions.filter((item: any) =>
            supportedArray.some((data: string) => item.value === data)
          )
        );

        setPreferredDateFormat(data[0].preferredDateFormat);
        setMetricSystem(data[0].metricSystem);
        setFilePath(data[0].tentantLogo);
        setFavIcon(data[0].favIcon);
        setRentalAgreementIcon(data[0].rentalAggrementLogo);
        setIsPretendEmails(data[0].pretendEmails ? "Yes" : "No");
        setReplyToEmail(data[0].replyToEmail);
        setIsDisabledSmsFailureNotificationEmails(data[0].disableSmsFailureNotificationEmails ? "Yes" : "No");
        setEmailForFailureNotifications(data[0].emailForFailureNotifications);
        setMainLayout(data[0].mailLayout);
        setEmailSignature(data[0].emailSignature);
        setMailFooter(data[0].mailFooter);
        setIsShowLogoOnEmails(data[0].showLogoOnEmails ? "Yes" : "No");
        setMailBarColor(data[0].mailBarColor);
        setEmailFilePath(data[0].mailBarLogo);
        setBaseUrl(data[0]?.baseUrl);
        setMailChimpKey(data[0].mailChimpKey);
        setMailgunSender(data[0].mailgunSender);
        setMailgunDomain(data[0].mailgunDomain);
        setGoogleAnalyticsKey(data[0].googleAnalyticsKey);
        setExtraCcUsersForSupportTickets(data[0].extraCCUsersForSuppportTickets);
        setWebsiteHeaderColor(data[0].websiteHeaderColor)
        setWebsiteHeaderSubColor(data[0].websiteHeaderSubColor)
        setWebsiteFooterColor(data[0].websiteFooterColor)
        setWebsiteFooterSubColor(data[0].websiteFooterSubColor)
        setWebsiteIndexPageImage(data[0].websiteIndexPageImage)
        setWebsiteSubPageImage(data[0].websiteSubPageImage)
        setWebsiteEmail(data[0].websiteEmail)
        setWebsitePhone(data[0].websitePhone)
        setWebsiteBranch(data[0].dataFetchingBranchId);
        setFacebookUrl(data[0]?.facebookUrl);
        setTwitterUrl(data[0]?.twitterUrl);
        setInstagramUrl(data[0]?.instagramUrl);
        setProcessRunTime(data[0]?.processRunTime);
        setrocessRunFrequency(data[0]?.processRunFrequency);
        setPleaseWaitPopup(false);
        handleTenantError(null);
      })
      .catch(error => {
        setPleaseWaitPopup(false);
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (SupportedLanguages) {
      const arrray = [];
      for (let i = 0; i < SupportedLanguages.length; i++) {
        arrray.push(SupportedLanguages[i]);
      }

      setSupportedLanguagesArray(arrray);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [SupportedLanguages]);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    setPleaseWaitPopup(true);
    await put_GeneralSetting({
      id,
      companyName,
      country,
      smsSender,
      timezone,
      language,
      SupportedLanguages: SupportedLanguages?.map((item: any) => item.value).join(","),
      preferredDateFormat,
      metricSystem,
      tentantLogo: filePath,
      favIcon,
      rentalAggrementLogo: rentalAgreementIcon,
      pretendEmails: isPretendEmails === "Yes" ? true : false,
      replyToEmail,
      disableSmsFailureNotificationEmails: isDisabledSmsFailureNotificationEmails === "Yes" ? true : false,
      emailForFailureNotifications,
      mailLayout: mainLayout,
      emailSignature,
      mailFooter,
      showLogoOnEmails: isShowLogoOnEmails === "Yes" ? true : false,
      mailBarColor,
      mailBarLogo: emailFilePath,
      baseUrl,
      mailChimpKey,
      mailgunSender,
      mailgunDomain,
      googleAnalyticsKey,
      extraCCUsersForSuppportTickets: extraCcUsersForSupportTickets,
      websiteHeaderColor,
      websiteHeaderSubColor,
      websiteFooterColor,
      websiteFooterSubColor,
      websiteIndexPageImage,
      websiteSubPageImage,
      websiteEmail,
      websitePhone,
      dataFetchingBranchId: websiteBranch,
      facebookUrl,
      twitterUrl,
      instagramUrl,
      processRunTime,
      processRunFrequency
    }, auth?.id, tenantId)
      .then(() => {
        setGeneralSetting({
          id,
          companyName,
          country,
          smsSender,
          timezone,
          timeZoneName: timezoneOptions?.find((item: any) => item?.value === timezone)?.label || "",
          language,
          SupportedLanguages: SupportedLanguages?.map((item: any) => item.value).join(","),
          preferredDateFormat,
          metricSystem,
          tentantLogo: filePath,
          favIcon,
          rentalAggrementLogo: rentalAgreementIcon,
          pretendEmails: isPretendEmails === "Yes" ? true : false,
          replyToEmail,
          disableSmsFailureNotificationEmails: isDisabledSmsFailureNotificationEmails === "Yes" ? true : false,
          emailForFailureNotifications,
          mailLayout: mainLayout,
          emailSignature,
          mailFooter,
          showLogoOnEmails: isShowLogoOnEmails === "Yes" ? true : false,
          mailBarColor,
          mailBarLogo: emailFilePath,
          baseUrl,
          mailChimpKey,
          mailgunSender,
          mailgunDomain,
          googleAnalyticsKey,
          extraCCUsersForSuppportTickets: extraCcUsersForSupportTickets,
          websiteHeaderColor,
          websiteHeaderSubColor,
          websiteFooterColor,
          websiteFooterSubColor,
          websiteIndexPageImage,
          websiteSubPageImage,
          websiteEmail,
          websitePhone,
          dataFetchingBranchId: websiteBranch,
          facebookUrl,
          twitterUrl,
          instagramUrl
        });

        const timezoneName = timezoneOptions?.find((item: any) => item?.value === timezone)?.label || "";
        let tzName = "UTC"; // fallback
        if (timezoneName) {
          const match = timezoneName.match(/\((.*?)\)\s(.*?)\s/);
          if (match && match[2]) tzName = match[2];
        }
        setTimezoneName(tzName);

        if (preferredDateFormat) {
          switch (parseInt(preferredDateFormat)) {
            case 0:
            case 4:
              setDateFormat("MM/DD/YYYY");
              break;
            case 1:
            case 2:
              setDateFormat("YYYY-MM-DD");
              break;
            case 3:
              setDateFormat("DD-MM-YYYY");
              break;
            case 5:
              setDateFormat("DD/MM/YYYY");
              break;
            case 6:
            case 8:
              setDateFormat("DD.MM.YYYY");
              break;
            case 7:
              setDateFormat("DD-MMM-YYYY");
              break;
            default:
              setDateFormat("MM/DD/YYYY");
          }
        } else {
          setDateFormat("MM/DD/YYYY");
        }

        setPleaseWaitPopup(false);
        handleTenantError(null);
      })
      .catch(error => {
        setPleaseWaitPopup(false);
        handleTenantError(error);
      });
  }

  const handleEdit = () => {
    setDisabled(false);
    setShowWebcam(false);
  };

  return (
    <div className={`p-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
      <div className={`w-full ${themeStyles.main.tailwindMainBg} rounded-lg p-[1px] flex flex-col`}>
        <div className="w-full">
          <div className={`w-full`}>
            <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
              <div className="flex items-center">
                <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Settings</h2>
              </div>

              {
                disabled && (
                  <button className={`px-[8px] py-[6px] bg-transparent shadow-sm rounded-lg border ${themeStyles.main.borderColor} text-white flex items-center gap-1.5`}
                    onClick={handleEdit}
                  >
                    <span className={`material-symbols-outlined text-[25px] font-light ${themeStyles.main.textSubHeadingColor}`}>
                      edit
                    </span>
                    <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>Edit</span>
                  </button>
                )
              }
            </div>

            <div className="p-2">
              <form
                className="w-3/4 p-[1.5rem] space-y-[1.5rem]"
                onSubmit={(e) => handleSubmit(e)}
              >
                <GeneralSettings
                  companyName={companyName}
                  setCompanyName={(value) => setCompanyName(value)}
                  country={country}
                  setCountry={(value) => setCountry(value)}
                  smsSender={smsSender}
                  setSmsSender={(value) => setSmsSender(value)}
                  timezone={timezone}
                  setTimezone={(value) => setTimezone(value)}
                  language={language}
                  setLanguage={(value) => setLanguage(value)}
                  supportedLanguagesOptions={supportedLanguagesOptions}
                  SupportedLanguages={SupportedLanguages}
                  setSupportedLanguages={(value) => setSupportedLanguages(value)}
                  supportedLanguagesArray={supportedLanguagesArray}
                  setSupportedLanguagesArray={(value) => setSupportedLanguagesArray(value)}
                  preferredDateFormat={preferredDateFormat}
                  setPreferredDateFormat={(value) => setPreferredDateFormat(value)}
                  metricSystem={metricSystem}
                  setMetricSystem={(value) => setMetricSystem(value)}
                  setPleaseWaitPopup={(value) => setPleaseWaitPopup(value)}
                  filePath={filePath}
                  setFilePath={(value) => setFilePath(value)}
                  favIcon={favIcon}
                  setFavIcon={setFavIcon}
                  rentalAgreementIcon={rentalAgreementIcon}
                  setRentalAgreementIcon={setRentalAgreementIcon}
                  disabled={disabled}
                  processRunTime={processRunTime}
                  setProcessRunTime={setProcessRunTime}
                  processRunFrequency={processRunFrequency}
                  setrocessRunFrequency={setrocessRunFrequency}
                  timezoneOptions={timezoneOptions}
                />

                <EmailSettings
                  isPretendEmails={isPretendEmails}
                  setIsPretendEmails={(value) => setIsPretendEmails(value)}
                  replyToEmail={replyToEmail}
                  setReplyToEmail={(value) => setReplyToEmail(value)}
                  isDisabledSmsFailureNotificationEmails={isDisabledSmsFailureNotificationEmails}
                  setIsDisabledSmsFailureNotificationEmails={(value) => setIsDisabledSmsFailureNotificationEmails(value)}
                  emailForFailureNotifications={emailForFailureNotifications}
                  setEmailForFailureNotifications={(value) => setEmailForFailureNotifications(value)}
                  mainLayout={mainLayout}
                  setMainLayout={(value) => setMainLayout(value)}
                  emailSignature={emailSignature}
                  setEmailSignature={(value) => setEmailSignature(value)}
                  mailFooter={mailFooter}
                  setMailFooter={(value) => setMailFooter(value)}
                  isShowLogoOnEmails={isShowLogoOnEmails}
                  setIsShowLogoOnEmails={(value) => setIsShowLogoOnEmails(value)}
                  mailBarColor={mailBarColor}
                  setMailBarColor={(value) => setMailBarColor(value)}
                  emailFilePath={emailFilePath}
                  setEmailFilePath={(value) => setEmailFilePath(value)}
                  baseUrl={baseUrl}
                  setBaseUrl={(value) => setBaseUrl(value)}
                  setPleaseWaitPopup={(value) => setPleaseWaitPopup(value)}
                  showWebcam={showWebcam}
                  setShowWebcam={(value) => setShowWebcam(value)}
                  disabled={disabled}
                />

                <Integration
                  mailChimpKey={mailChimpKey}
                  setMailChimpKey={(value) => setMailChimpKey(value)}
                  mailgunSender={mailgunSender}
                  setMailgunSender={(value) => setMailgunSender(value)}
                  mailgunDomain={mailgunDomain}
                  setMailgunDomain={(value) => setMailgunDomain(value)}
                  googleAnalyticsKey={googleAnalyticsKey}
                  setGoogleAnalyticsKey={(value) => setGoogleAnalyticsKey(value)}
                  extraCcUsersForSupportTickets={extraCcUsersForSupportTickets}
                  setExtraCcUsersForSupportTickets={(value) => setExtraCcUsersForSupportTickets(value)}
                  disabled={disabled}
                />

                <Website
                  websiteHeaderColor={websiteHeaderColor}
                  setWebsiteHeaderColor={setWebsiteHeaderColor}
                  websiteHeaderSubColor={websiteHeaderSubColor}
                  setWebsiteHeaderSubColor={setWebsiteHeaderSubColor}
                  websiteFooterColor={websiteFooterColor}
                  setWebsiteFooterColor={setWebsiteFooterColor}
                  websiteFooterSubColor={websiteFooterSubColor}
                  setWebsiteFooterSubColor={setWebsiteFooterSubColor}
                  websiteIndexPageImage={websiteIndexPageImage}
                  setWebsiteIndexPageImage={setWebsiteIndexPageImage}
                  websiteSubPageImage={websiteSubPageImage}
                  setWebsiteSubPageImage={setWebsiteSubPageImage}
                  websiteEmail={websiteEmail}
                  setWebsiteEmail={setWebsiteEmail}
                  websitePhone={websitePhone}
                  setWebsitePhone={setWebsitePhone}
                  websiteBranch={websiteBranch}
                  setWebsiteBranch={setWebsiteBranch}
                  setPleaseWaitPopup={setPleaseWaitPopup}
                  disabled={disabled}
                />

                <SocialMedia
                  facebookUrl={facebookUrl}
                  setFacebookUrl={setFacebookUrl}
                  twitterUrl={twitterUrl}
                  setTwitterUrl={setTwitterUrl}
                  instagramUrl={instagramUrl}
                  setInstagramUrl={setInstagramUrl}
                  disabled={disabled}
                />

                <Advanced />

                <Security />

                <div className="flex gap-4 mt-6">
                  {
                    !disabled && (
                      <Button variant="contained"
                        sx={{
                          backgroundColor: colorConfigs.btn.main.bg
                        }}
                        type="submit">
                        Save
                      </Button>
                    )
                  }
                </div>
              </form>

              <PleaseWaitPopup pleaseWaitPopup={pleaseWaitPopup} />

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

